import packageJson from '../../package.json'

let cachedVersion: string | null = null

/**
 * Get the current version from package.json
 * This function caches the result for better performance
 * Much faster than executing git commands on every request
 */
export function getCurrentGitTag(): string {
  if (cachedVersion !== null) {
    return cachedVersion
  }

  try {
    cachedVersion = packageJson.version || 'unknown'
    return cachedVersion
  } catch (error) {
    console.warn('Unable to read version from package.json:', error)
    cachedVersion = 'unknown'
    return cachedVersion
  }
}

/**
 * Reset the cached version (useful for development/testing)
 */
export function resetGitTagCache(): void {
  cachedVersion = null
}
